import { Tile, NumberFormatter } from "@uicore";
import { Stack } from "@altimateai/lego";
import { useAppState } from "@/modules/app/useAppContext";
import classes from "../../../summary/summary.module.scss";
import type { SavingsData } from "../types";

interface Props {
  isFuture: boolean;
  startDateStr: string;
  endDateStr: string;
  savingsPeriod: string;
  savings: SavingsData | null;
}

const DatabricksSavingsTiles = ({
  isFuture,
  startDateStr,
  endDateStr,
  savingsPeriod,
  savings,
}: Props) => {
  const { currency } = useAppState();

  return (
    <div className={classes.tileWrap}>
      <Tile
        color="#01CD8C"
        title="Total Money Savings"
        helpText={
          isFuture
            ? `Projected cost savings from opportunities for ${savingsPeriod === "thisYear" ? "this year" : "the next year"}`
            : `Potential cost savings from opportunities identified from ${startDateStr} to ${endDateStr}`
        }
        value={<NumberFormatter value={savings?.total ?? 0} options={{ currency }} />}
      >
        <Stack direction="column">
          <Tile
            title="Autonomous Money Savings"
            helpText={
              isFuture
                ? "Projected savings from automated optimizations (always $0 for Databricks - no automated agents)"
                : "Cost saved automatically by the product (always $0 for Databricks - no automated agents)"
            }
            value={<NumberFormatter value={savings?.autonomous ?? 0} options={{ currency }} />}
          />
          <Tile
            title="Assisted Money Savings"
            helpText={
              isFuture
                ? "Projected savings if users implement the identified opportunities (rightsizing clusters, fixing failed jobs)"
                : "Potential cost savings if users implement the opportunities identified (rightsizing clusters, fixing failed jobs)"
            }
            value={<NumberFormatter value={savings?.assisted ?? 0} options={{ currency }} />}
          />
        </Stack>
      </Tile>
      <Tile
        title="Total Time Savings"
        helpText="Estimated time savings from reducing wasted compute hours on oversized resources and failed jobs"
        value={(savings?.timeSaved ?? "0 days").toLowerCase()}
        className={classes.time_saved}
      />
    </div>
  );
};

export default DatabricksSavingsTiles;
